import { getAprProjections } from "./get-apr-projections";
import { getIrmMeta } from "./get-irm-meta";
import { getMarketAssetState } from "./get-market-asset-state";
import { getMarketAssetUserState } from "./get-market-asset-user-state";
import { getMarketMeta } from "./get-market-meta";
import { getMarketUserState } from "./get-market-user-state";
import { getNativeRewardsBalance } from "./get-native-rewards-balance";
import { getProtocolShareFee } from "./get-protocol-share-fee";
import {
  getChainlinkQuotePrice,
  getQuotePrice,
  getUniswapQuotePrice,
} from "./get-quote-price";
import { getRewardsEmissions } from "./get-rewards-emissions";
import { getRouterAddress } from "./get-router-address";
import { getTokenBalance } from "./get-token-balance";
import { ContractsClientError } from "./types";

export const ContractsClient = {
  ContractsClientError,

  getAprProjections,
  getChainlinkQuotePrice,
  getIrmMeta,
  getMarketAssetState,
  getMarketAssetUserState,
  getMarketMeta,
  getMarketUserState,
  getNativeRewardsBalance,
  getProtocolShareFee,
  getQuotePrice,
  getRewardsEmissions,
  getRouterAddress,
  getTokenBalance,
  getUniswapQuotePrice,
};
